import React from "react";
import { Navigate } from "react-router-dom";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import AuthLockScreen from "../pages/Authentication/AuthLockScreen";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

// Utility Pages
import Maintenance from "../pages/Utility/Maintenance";
import ComingSoon from "../pages/Utility/CommingSoon";
import Error404 from "../pages/Utility/Error404";
import Error500 from "../pages/Utility/Error500";
import UnAuthorized from "../pages/Utility/UnAuthorized";

// Other Pages
import Office from "../pages/office";
import ClassRooms from "../pages/classes/ClassRooms";
import DepartmentList from "../pages/Hr/Department/List";
import DesignationList from "../pages/Hr/Designation/List";
import StaffList from "../pages/Hr/Staffs/List";
import StaffAttendance from "../pages/Hr/Staffs/Attendence";
import StaffLeaves from "../pages/Hr/Leaves/List";
import CollectFee from "../pages/Finance/CollectFee/CollectFee";
import Holidays from "../pages/Holidays/Holiday";
import Event from "../pages/Events/Event";
import StudentReport from "../pages/Reports/StudentReport";
import TeacherReport from "../pages/Reports/TeacherReport";
import Landing from "../pages/LandingPage/LandingPage";
import AcademicYears from "../pages/office/AcademicYears";

//teacher
import ReportCard from "../pages/Reports/ReportCard";

//parent
import Profile from "../pages/Admin/Profile";
import StaffProfile from "../pages/Hr/Staffs/StaffProfile";
import Buildings from "../pages/office/Buildings";
import IncomeList from "../pages/Finance/Accounts/IncomeList";
import IncomeHeadList from "../pages/Finance/Accounts/IncomeHeadList";
import ExpenseHeadList from "../pages/Finance/Accounts/ExpenseHeadList";
import ExpenseList from "../pages/Finance/Accounts/ExpenseList";
import BalanceFeeStatement from "../pages/Reports/Finance Report/BalanceFeeStatement.jsx";
import DailyCollectionReport from "../pages/Reports/Finance Report/DailyCollectionReports.jsx";
import FeeStatement from "../pages/Reports/Finance Report/FeeStatement.jsx";
import IncomeReport from "../pages/Reports/Finance Report/IncomeReport.jsx";
import ExpenseReport from "../pages/Reports/Finance Report/ExpenseReport.jsx";
import PayrollReport from "../pages/Reports/Finance Report/PayRollReport.jsx";
import LeadsList from "../pages/sales & leads/Leads/Leads.jsx";
import ClientsList from "../pages/sales & leads/Leads/Clients.jsx";
import ProjectsList from "../pages/Projects/CreateProjects.jsx";
import StaffDashboard from "../pages/StaffUser/Dashboard/index.jsx";
import BlogList from "../pages/website/BlogList.jsx";
import BlogAdd from "../pages/website/AddBlog.jsx";
import PortfolioAdd from "../pages/website/AddPortfolio.jsx";
import View from "../pages/Projects/View.jsx";
import StaffPortfolio from "../pages/Hr/Staffs/Portfoliio.jsx";



import InvoiceList from "../pages/Finance/Accounts/InvoiceList.jsx";
import InvoiceDetail from "../pages/Finance/Accounts/InvoceDetails.jsx";
import StaffBlogList from "../pages/StaffUser/Blog/BlogList.jsx";
import StaffBlogAdd from "../pages/StaffUser/Blog/AddBlog.jsx";
import TaskList from "../pages/Tasks/List.jsx";
import StaffAttendanceReport from "../pages/Hr/Staffs/AttendanceReport.jsx";
import ScheduledTaskList from "../pages/Tasks/Scheduled-task-list.jsx";
import PortfolioList from "../pages/website/PortfolioList.jsx";
import LuckyDrawList from "../pages/LuckyDraw/LuckyDrawList.jsx";
import WebAuditList from "../pages/WebAudit/WebAuditList.jsx";



//  Auth Protected Routes
const authProtectedRoutes = [
	//  Admin Routes
	{ path: "/admin/dashboard", component: <Dashboard />, allowedRoles: ["admin"] },
	{ path: "/admin/profile", component: <Profile />, allowedRoles: ["admin"] },
	{ path: "/staff-profile", component: <StaffProfile />, allowedRoles: ["admin"] },

	{ path: "/admin/class-rooms", component: <ClassRooms />, allowedRoles: ["admin"] },
	{ path: "/admin/office", component: <Office />, allowedRoles: ["admin"] },
	{ path: "/admin/academic-years", component: <AcademicYears />, allowedRoles: ["admin"] },
	{ path: "/admin/buildings", component: <Buildings />, allowedRoles: ["admin"] },
	{ path: "/admin/office/staff", component: <StaffList />, allowedRoles: ["admin"] },
	{ path: "/admin/office/departments", component: <DepartmentList />, allowedRoles: ["admin"] },
	{ path: "/admin/office/designations", component: <DesignationList />, allowedRoles: ["admin"] },
	{ path: "/admin/office/website/blogs", component: <BlogList />, allowedRoles: ["admin"] },
	{ path: "/admin/office/website/addblog", component: <BlogAdd />, allowedRoles: ["admin"] },
	{ path: "/admin/office/website/portfolios", component: <PortfolioList />, allowedRoles: ["admin"] },
	{ path: "/admin/office/website/addportfolio", component: <PortfolioAdd />, allowedRoles: ["admin"] },
	{ path: "/admin/office/staff-portfolio/:id", component: <StaffPortfolio />, allowedRoles: ["admin", "staff"] },
	{ path: "/admin/salesandleads/leads", component: <LeadsList />, allowedRoles: ["admin"] },
	{ path: "/admin/salesandleads/clients", component: <ClientsList />, allowedRoles: ["admin"] },
	{ path: "/admin/projectsandtasks/projects", component: <ProjectsList />, allowedRoles: ["admin"] },
	{ path: "/admin/office/attendance", component: <StaffAttendance />, allowedRoles: ["admin"] },
	{ path: "/admin/office/attendance-report", component: <StaffAttendanceReport />, allowedRoles: ["admin"] },
	{ path: "/admin/leaves", component: <StaffLeaves />, allowedRoles: ["admin"] },
	{ path: "/admin/collect-fee", component: <CollectFee />, allowedRoles: ["admin"] },
	{ path: "/admin/holidays", component: <Holidays />, allowedRoles: ["admin"] },
	{ path: "/admin/events", component: <Event />, allowedRoles: ["admin"] },
	{ path: "/admin/student-report", component: <StudentReport />, allowedRoles: ["admin"] },
	{ path: "/admin/teacher-report", component: <TeacherReport />, allowedRoles: ["admin"] },
	{ path: "/admin/report", component: <ReportCard />, allowedRoles: ["admin"] },
	{ path: "/admin/report/balance-fee-statement", component: <BalanceFeeStatement />, allowedRoles: ["admin"] },
	{ path: "/admin/report/daily-report-collections", component: <DailyCollectionReport />, allowedRoles: ["admin"] },
	{ path: "/admin/report/fee-statement", component: <FeeStatement />, allowedRoles: ["admin"] },
	{ path: "/admin/report/income-report", component: <IncomeReport />, allowedRoles: ["admin"] },
	{ path: "/admin/report/expense-report", component: <ExpenseReport />, allowedRoles: ["admin"] },
	{ path: "/admin/report/payroll-report", component: <PayrollReport />, allowedRoles: ["admin"] },
	{ path: "/admin/projects/:id", component: <View />, allowedRoles: ["staff", "admin"] },
	{ path: "/admin/luckydraw", component: <LuckyDrawList />, allowedRoles: ["admin"] },
	{ path: "/admin/webaudit", component: <WebAuditList />, allowedRoles: ["admin"] },
	{ path: "/admin/accounts/invoice", component: <InvoiceList />, allowedRoles: ["admin", "staff"] },
	{ path: "/admin/accounts/invoice/:client_id", component: <InvoiceDetail />, allowedRoles: ["admin", "staff"] },

	{ path: "/admin/incomes", component: <IncomeList />, allowedRoles: ["admin"] },
	{ path: "/admin/income-heads", component: <IncomeHeadList />, allowedRoles: ["admin"] },
	{ path: "/admin/expense", component: <ExpenseList />, allowedRoles: ["admin"] },
	{ path: "/admin/expense-heads", component: <ExpenseHeadList />, allowedRoles: ["admin"] },



	//  Staff Routes
	{ path: "/staff/dashboard", component: <StaffDashboard />, allowedRoles: ["staff"] },
	{ path: "/staff/dashboard", component: <Dashboard />, allowedRoles: ["staff"] },
	// { path: "/staff/profile", component: <Profile />, allowedRoles: ["staff"] },
	{ path: "/staff/profile", component: <StaffProfile />, allowedRoles: ["staff"] },


	{ path: "/staff/office", component: <Office />, allowedRoles: ["staff"] },
	{ path: "/staff/academic-years", component: <AcademicYears />, allowedRoles: ["staff"] },
	{ path: "/staff/list-staff", component: <StaffList />, allowedRoles: ["staff"] },
	{ path: "/staff/office/departments", component: <DepartmentList />, allowedRoles: ["staff"] },
	{ path: "/staff/office/designations", component: <DesignationList />, allowedRoles: ["staff"] },
	{ path: "/staff/salesandleads/leads", component: <LeadsList />, allowedRoles: ["staff"] },
	{ path: "/staff/salesandleads/clients", component: <ClientsList />, allowedRoles: ["staff"] },
	{ path: "/staff/projectsandtasks/projects", component: <ProjectsList />, allowedRoles: ["staff",] },
	{ path: "/staff/projectsandtasks/tasks", component: <TaskList />, allowedRoles: ["staff", "admin"] },
	{ path: "/staff/projectsandtasks/scheduledtasks", component: <ScheduledTaskList />, allowedRoles: ["staff", "admin"] },
	{ path: "/staff/attendance", component: <StaffAttendance />, allowedRoles: ["staff"] },
	{ path: "/staff/leaves", component: <StaffLeaves />, allowedRoles: ["staff"] },
	{ path: "/staff/holidays", component: <Holidays />, allowedRoles: ["staff"] },
	{ path: "/staff/events", component: <Event />, allowedRoles: ["staff"] },
	{ path: "/staff/student-report", component: <StudentReport />, allowedRoles: ["staff"] },
	{ path: "/staff/teacher-report", component: <TeacherReport />, allowedRoles: ["staff"] },
	{ path: "/staff/report", component: <ReportCard />, allowedRoles: ["staff"] },
	{ path: "/staff/report/balance-fee-statement", component: <BalanceFeeStatement />, allowedRoles: ["staff"] },
	{ path: "/staff/report/daily-report-collections", component: <DailyCollectionReport />, allowedRoles: ["staff"] },
	{ path: "/staff/report/fee-statement", component: <FeeStatement />, allowedRoles: ["staff"] },
	{ path: "/staff/report/income-report", component: <IncomeReport />, allowedRoles: ["staff"] },
	{ path: "/staff/report/expense-report", component: <ExpenseReport />, allowedRoles: ["staff"] },
	{ path: "/staff/report/payroll-report", component: <PayrollReport />, allowedRoles: ["staff"] },

	{ path: "/staff/incomes", component: <IncomeList />, allowedRoles: ["staff"] },
	{ path: "/staff/income-heads", component: <IncomeHeadList />, allowedRoles: ["staff"] },
	{ path: "/staff/expense", component: <ExpenseList />, allowedRoles: ["staff"] },
	{ path: "/staff/expense-heads", component: <ExpenseHeadList />, allowedRoles: ["staff"] },
	{ path: "/staff/my-tasks", component: <TaskList />, allowedRoles: ["staff", "admin"] },

	{ path: "/staff/office/website/blogs", component: <StaffBlogList />, allowedRoles: ["staff"] },
	{ path: "/staff/office/website/addblog", component: <StaffBlogAdd />, allowedRoles: ["staff"] },






	//  Fallback Redirect for Authenticated Users
	{
		path: "*",
		component: () => {
			const user = JSON.parse(localStorage.getItem("user") || "{}");
			const userRoles = user?.type ? user.type.split(",") : [];

			console.log("Redirecting based on roles:", userRoles); // Debugging

			if (userRoles.includes("admin")) return <Navigate to="/admin/dashboard" />;
			if (userRoles.includes("staff")) return <Navigate to="/staff/dashboard" />;

			return <Navigate to="/unauthorized" />;
		},
		allowedRoles: ["admin", "staff"],
	}
];

const publicRoutes = [
	{ path: "/", component: <Login /> },
	{ path: "/logout", component: <Logout /> },
	{ path: "/login", component: <Login /> },
	{ path: "/forgot-password", component: <ForgetPwd /> },
	{ path: "/register", component: <Register /> },
	{ path: "/lock-screen", component: <AuthLockScreen /> },
	{ path: "/maintenance", component: <Maintenance /> },
	{ path: "/comingsoon", component: <ComingSoon /> },
	{ path: "/404", component: <Error404 /> },
	{ path: "/500", component: <Error500 /> },
	{ path: "/unauthorized", component: <UnAuthorized /> },
	{ path: "/xchools", component: <Landing /> },
];

export { authProtectedRoutes, publicRoutes };
